import React, { Component } from 'react'
import styles from './styles.css'
import {
  defineMessages,
  FormattedMessage,
  FormattedHTMLMessage,
  injectIntl
} from 'react-intl'
import Modal from 'components/Modal'
import Icon from 'components/icons'
import colors from '../../styles/colors.css'
import cn from 'classnames'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'components/Button'
import {
  COUPON_ALL,
  COUPON_LOCAL,
  COUPON_REMOTE,
  BALANCE,
  PARTICIPANT,
  DECLINE,
  FREE
} from 'constants/paymentMethods'
import {
  INITIATOR,
  RECIPIENT
} from 'constants/payerTypes'
import FormattedCurrency from 'components/FormattedCurrency'

const messages = defineMessages({
  title: 'Disclosures & Payment',
  recipientPay: 'has requested <strong>you pay</strong> for this visit.',
  freeCall: 'This is a <strong>free</strong> video visit.',
  doNotRecord: 'Video visit will <strong>not</strong> be recorded.',
  cost: 'Video Visit Cost',
  free: 'Free',
  hourPluralized: `{hours, number} {hours, plural, one {hr} other {hrs}}`,
  minPluralized: `{mins, number} {mins, plural, one {min} other {mins}}`,
  min: 'min',
  minutes: 'Minutes',
  limit: 'Video Visit Limit',
  methodFreeMinutes: '<strong>Use Free Visit Minutes</strong> to pay',
  balanceRemaining: 'remaining',
  couponLocal: 'Local Only',
  couponRemote: 'Remote Only',
  couponAll: 'Local or Remote',
  useBalance: '<strong>Use My Balance</strong> to pay',
  useParticipant: '<strong>will pay</strong> for the Video Visit',
  decline: 'Decline Visit',
  billedPerMinute: '<strong>Video Visit cost is per minute.</strong> You only pay for what you use.',
  monitored: 'This video call may be monitored and recorded. It may be shared with law enforcement, and may be used as evidence in a criminal or civil proceeding.',
  nonPay: 'If the other party is unable to pay, the call will be declined.',
  approximately: 'est.',
  declineButtonText: 'I Decline',
  agreeButtonText: 'I Agree',
  confirmWindowText: 'Are you sure?',
  incomingCallHeader: 'Incoming video call from inmate <strong>{otherUser}</strong>'
})

export class BillingModal extends Component {
  constructor(props) {
    super(props)
    this.onPaymentClick = this.onPaymentClick.bind(this)
    this.onPaymentOptionChange = this.onPaymentOptionChange.bind(this)
    this.agree = this.agree.bind(this)
    this.decline = this.decline.bind(this)
    this.closeAndRedirect = this.closeAndRedirect.bind(this)
  }

  approximateMinutes(intl, balance, rate) {
    const approximation = parseInt(balance / rate),
      hours = parseInt(approximation / 60) || 0,
      mins = hours ? parseInt((approximation % 60)) : approximation,
      friendlyEst = [intl.formatMessage(messages.approximately)]
    if (hours) {
      friendlyEst.push(intl.formatMessage(messages.hourPluralized, { hours }))
    }
    friendlyEst.push(intl.formatMessage(messages.minPluralized, { mins }))
    return friendlyEst.join(' ')
  }

  agree() {
    const {
      payment,
      payer,
      closeModal,
      isInitiator,
      createVisit,
      visitInfo,
      rate,
      acceptVisit
    } = this.props
    const freeVisit = rate <= 0
    if (!payment && !payer && !freeVisit) return
    if (isInitiator && (payment || freeVisit)) {
      const paymentInfo = {
        payer: payment === PARTICIPANT ? RECIPIENT : INITIATOR
      }
      let paymentMethod = payment !== PARTICIPANT ? rate <= 0 ? FREE : payment : undefined
      if (paymentMethod) {
        paymentInfo.paymentMethod = paymentMethod
      }
      createVisit({...visitInfo, ...paymentInfo})
    }
    if (!isInitiator) {
      acceptVisit(payment)
    }
    closeModal()
  }

  decline() {
    const {
      declineVisit,
      cancelVisit,
      isInitiator,
      confirmDialog
    } = this.props
    confirmDialog(() => {
      if (isInitiator) {
        cancelVisit(this.closeAndRedirect)
      } else {
        declineVisit(this.closeAndRedirect)
      }
    })
  }

  closeAndRedirect() {
    const {
      closeModal,
      redirectURL
    } = this.props
    closeModal()
    if (redirectURL) {
      window.location.replace(redirectURL)
    }
  }

  onPaymentClick(selectionValue, predicate) {
    if (predicate) this.props.setPayment(selectionValue)
  }

  onPaymentOptionChange(e) {
    this.props.setPayment(e.target.value)
  }

  render() {
    const {
      intl,
      show,
      isInitiator,
      payer,
      doNotRecord,
      otherUser,
      rate,
      maximumDuration,
      couponAll,
      couponLocal,
      couponRemote,
      balance,
      payment
    } = this.props

    const noOptions = rate > 0 && !isInitiator && !payer && balance <= 0 && couponAll <= 0 && couponLocal <= 0 && couponRemote <= 0
    const hasCouponPlan = !!(couponAll || couponLocal || couponRemote)
    const canNotUseBalance = balance <= rate
    const freeVisit = rate <= 0

    return (
      <Modal
        title={(<FormattedMessage {...messages.title} />)}
        show={show}
        modalClassName={styles.modal}
        headerClassName={styles.modalHeader}
        bodyClassName={styles.modalBody}
        footerClassName={styles.modalFooter}
        footer={(
          <Container>
            { payment !== DECLINE && !noOptions && (
              <Row>
                <Col xs={6}>
                  <Button
                    type='cancel'
                    onClick={this.decline}
                  >
                    <FormattedMessage {...messages.declineButtonText} />
                  </Button>
                </Col>
                <Col xs={6}>
                  <Button
                    disabled={!payment && !payer && !freeVisit}
                    type='go'
                    onClick={this.agree}
                  >
                    <FormattedMessage {...messages.agreeButtonText} />
                  </Button>
                </Col>
              </Row>
            )}
            { (payment === DECLINE || noOptions) && (
              <Row>
                <Col xs={12}>
                  <Button
                    type='decline'
                    onClick={this.decline}
                  >
                    <FormattedMessage {...messages.decline} />
                  </Button>
                </Col>
              </Row>
            )}
          </Container>
        )}
      >
        <div styleName='billingModalBody'>
          { !isInitiator && (
              <div>
                <hr/>
                <div styleName='paymentMessage'>
                  <div styleName='multilineLabel'>
                    {/*<Icon name='usd-round' className={styles.iconSmall} fill={'#fff'} />*/}
                    <FormattedHTMLMessage {...messages.incomingCallHeader} values={{otherUser}} />
                  </div>
                </div>
              </div>
          )}

          { !isInitiator && !payer && !freeVisit && (
            <div>
              <hr/>
              <div styleName='paymentMessage'>
                <div styleName='multilineLabel'>
                  <Icon name='usd-round' className={styles.iconSmall} fill={'#fff'} />
                  <strong>{otherUser}</strong>&nbsp;<FormattedHTMLMessage {...messages.recipientPay} />
                </div>
              </div>
            </div>
          )}

          { freeVisit && !payer && (
            <div data-testid='freeCall'>
              <hr/>
              <div styleName='paymentMessage'>
                <div styleName='multilineLabel'>
                  <Icon name='usd-round' className={styles.iconSmall} fill={'#fff'} />
                  <FormattedHTMLMessage {...messages.freeCall} />
                </div>
              </div>
            </div>
          )}

          { doNotRecord && (
            <div data-testid='doNotRecord'>
              <hr/>
              <div styleName='paymentMessage'>
                <div styleName='multilineLabel'>
                  <Icon name='no-record' width={41} fill={'#fff'} />
                  <FormattedHTMLMessage {...messages.doNotRecord} />
                </div>
              </div>
            </div>
          )}

          <hr/>

          { (isInitiator || !payer || freeVisit) && (
            <div styleName='detail'>
              <p data-testid='cost'>
                <FormattedMessage {...messages.cost} />:
                {' '}
                { !freeVisit && (
                  <strong>
                    <FormattedCurrency value={rate / 100} />
                    /
                    <FormattedMessage {...messages.min} />
                  </strong>
                )}
                { freeVisit && (
                  <strong>
                    <FormattedMessage {...messages.free} />
                  </strong>
                )}
              </p>
              <p data-testid='limit'>
                <FormattedMessage {...messages.limit} />:
                {' '}
                <strong>{maximumDuration} <FormattedMessage {...messages.min} /></strong>
              </p>
            </div>
          )}

          <hr/>

          { !payer && !freeVisit && (
            <div data-testid='payments' styleName='selections'>
              <form>
                { hasCouponPlan && couponAll !== undefined && (
                  <div data-testid='couponAllPayment' styleName='selection' onClick={() => this.onPaymentClick(COUPON_ALL, couponAll > 0)}>
                    <input disabled={couponAll <= 0} type='radio' name='payment-method' checked={payment === COUPON_ALL}
                           onChange={this.onPaymentOptionChange} value={COUPON_ALL} />
                    <div styleName={cn('labelBlock', { disabled: couponAll <= 0})}>
                      <Icon name='minutes' className={styles.iconLarge} fill={colors.sec5} />
                      <div styleName='multilineLabel'>
                        <p><FormattedHTMLMessage {...messages.methodFreeMinutes} /></p>
                        <p styleName='sub'>
                          {couponAll}
                          {' '}
                          <FormattedMessage {...messages.minutes }/>
                          {' '}
                          <FormattedMessage {...messages.balanceRemaining }/>
                          {' '}
                          (<FormattedMessage {...messages.couponAll }/>)
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                { hasCouponPlan && couponLocal !== undefined && (
                  <div data-testid='couponLocalPayment' styleName='selection' onClick={() => this.onPaymentClick(COUPON_LOCAL, couponLocal > 0)}>
                    <input disabled={couponLocal <= 0} type='radio' name='payment-method' checked={payment === COUPON_LOCAL}
                           onChange={this.onPaymentOptionChange} value={COUPON_LOCAL} />
                    <div styleName={cn('labelBlock', { disabled: couponLocal <= 0})}>
                      <Icon name='minutes' className={styles.iconLarge} fill={colors.sec5} />
                      <div styleName='multilineLabel'>
                        <p><FormattedHTMLMessage {...messages.methodFreeMinutes} /></p>
                        <p styleName='sub'>
                          {couponLocal}
                          {' '}
                          <FormattedMessage {...messages.minutes }/>
                          {' '}
                          <FormattedMessage {...messages.balanceRemaining }/>
                          {' '}
                          (<FormattedMessage {...messages.couponLocal }/>)
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                { hasCouponPlan && couponRemote !== undefined && (
                  <div data-testid='couponRemotePayment' styleName='selection' onClick={() => this.onPaymentClick(COUPON_REMOTE, couponRemote > 0)}>
                    <input disabled={couponRemote <= 0} type='radio' name='payment-method' checked={payment === COUPON_REMOTE}
                           onChange={this.onPaymentOptionChange} value={COUPON_REMOTE} />
                    <div styleName={cn('labelBlock', { disabled: couponRemote <= 0})}>
                      <Icon name='minutes' className={styles.iconLarge} fill={colors.sec5} />
                      <div styleName='multilineLabel'>
                        <p><FormattedHTMLMessage {...messages.methodFreeMinutes} /></p>
                        <p styleName='sub'>
                          {couponRemote}
                          {' '}
                          <FormattedMessage {...messages.minutes }/>
                          {' '}
                          <FormattedMessage {...messages.balanceRemaining }/>
                          {' '}
                          (<FormattedMessage {...messages.couponRemote }/>)
                        </p>
                      </div>
                    </div>
                  </div>
                )}


                <div data-testid='balancePayment' styleName='selection' onClick={() => this.onPaymentClick(BALANCE, !canNotUseBalance)}>
                  <input disabled={canNotUseBalance} type='radio' name='payment-method' checked={payment === BALANCE}
                         onChange={this.onPaymentOptionChange} value={BALANCE} />
                  <div styleName={cn('labelBlock', { disabled: canNotUseBalance})}>
                    <Icon name='usd-round' className={styles.iconLarge} fill={colors.sec5} />
                    <div styleName='multilineLabel'>
                      <p><FormattedHTMLMessage {...messages.useBalance} /></p>
                      <p styleName='sub'>
                        <FormattedCurrency value={balance / 100} />
                        {' '}
                        <FormattedMessage {...messages.balanceRemaining }/>
                        {' '}
                        { !freeVisit && (
                          <span>({this.approximateMinutes(intl, balance, rate)})</span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                { isInitiator && (
                  <div data-testid='otherUserPayment' styleName='selection' onClick={() => this.onPaymentClick(PARTICIPANT, !freeVisit)}>
                    <div>
                      <input disabled={freeVisit} type='radio' name='payment-method' checked={payment === PARTICIPANT}
                             onChange={this.onPaymentOptionChange} value={PARTICIPANT} />
                      <div styleName={cn('labelBlock', { disabled: freeVisit})}>
                        <div styleName='multilineLabel'>
                          <p>
                            <strong>{otherUser}</strong>&nbsp;<FormattedHTMLMessage {...messages.useParticipant} />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                { !isInitiator && (
                  <div styleName='selection' onClick={() => this.onPaymentClick(DECLINE, true)}>
                    <div>
                      <input type='radio' name='payment-method' data-ng-model='payment' checked={payment === DECLINE || noOptions}
                             onChange={this.onPaymentOptionChange} value={DECLINE} />
                      <div styleName='multilineLabel'>
                        <p>
                          <FormattedMessage {...messages.decline} />
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
        <hr/>
        <div data-testid='legalNotes' styleName='legal'>
          { (isInitiator || !payer) && !freeVisit && (
            <FormattedHTMLMessage {...messages.billedPerMinute} />
          )}

          { !doNotRecord && (
            <p><FormattedMessage {...messages.monitored} /></p>
          )}

          { payment === PARTICIPANT && (
            <p><FormattedMessage {...messages.nonPay} /></p>
          )}
        </div>
      </Modal>
    )
  }
}

export default injectIntl(BillingModal)
